import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { TqueuePosition } from '@/logic/_infra/queues';
import { dragEventRef } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'

import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import * as personController from '@/ops/workspaces/person.processor'
import { useAppContext } from '@/app/_tech';
import sys from '@/sys';
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { computed } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'TicketSlot',
  props: {
    person_model: {},
    level: {}
  },
  emits: {
    resume: null,
    },
  setup(__props: any, { emit: __emit }) {

const props = __props

const context = useAppContext()

const workable = computed(() => props.person_model.todo_next() != null)

const emit = __emit

function onCurrentDragLeave(e: DragEvent) {

}


function onCurrentDragOver(e: DragEvent) {



}

function onCurrentDragEnter(e: DragEvent) {

}

function onCurrentDrop(e: DragEvent) {


  const p = props.person_model;

  const ref = dragEventRef(e)

  if (ref != null) personController.queueEntity(context, p, ref, new TqueuePosition("current"))

  const target = e.target;

  const element = target as HTMLElement

  element.classList.remove('dev-box')
}

function onResume() {

  // const item = props.person_model.todo_next()

  // if (item != null) personController.queueEntity_todo(context, item, new TqueuePosition("current"))

  // else sys.warn('Null todo on resume')

  emit('resume')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onDragenter: _withModifiers(onCurrentDragEnter, ["prevent"]),
    onDragover: _withModifiers(onCurrentDragOver, ["prevent"]),
    onDragleave: onCurrentDragLeave,
    onDrop: onCurrentDrop
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (workable.value && (_ctx.level ?? _unref(TicketAccessLevel).None) >= _unref(TicketAccessLevel).Normal)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _withModifiers(onResume, ["stop"])
        }, "Resume"))
      : _createCommentVNode("", true)
  ], 32))
}
}

})